module.exports = __webpack_public_path__ + "img/yash9815@schulich.yorku.ca-0.f1985bc0.jpg";